import React, { useEffect, useState } from "react";
import TopBar from "./TopBar/TopBar";
import { AppProvider } from "../stores/application.store";
import VoteOver from "../components/Pages/VoteOver/VoteOver";
import PageView from "./PageView/PageView";

const App = () => {
  const [voteActive, setVoteActive] = useState(true);

  useEffect(() => {
    let finishDate = new Date("2020/12/27 23:55:01");
    console.log(finishDate);
    console.log(new Date());
    if (finishDate <= new Date()) {
      setVoteActive(false);
    }
  }, []);
  if (voteActive) {
    return (
      <AppProvider>
        <TopBar />
        <PageView />
      </AppProvider>
    );
  }
  else{
    return(
      <VoteOver />
    )
  }
};

export default App;
